import React , { useState } from 'react'

import { Link } from 'react-router-dom'


export default function FooterDark() {

  const [seeTerms, setSeeTerms] = useState(false)

  return (
    <div
        className='dontPrint'
        style={{
            width: '100%',
            color: "#292929",
            background: '#FFF',
            fontSize: '14px',
            textAlign: 'center',
            margin: "200px 0 0 0",
        }}
    >
        <hr
        style={{
          width: '100%',
          margin: '0',
        }}
      >
      </hr> 
      <div
        style={{
          display:'flex',
          justifyContent: 'space-evenly',
          padding: '3px 0 16px 0',
        }}
      >
        <p
          style={{
            margin: '0',
          }}
        >
          Copyright © 2024 Research Synthase
        </p>
        <a
            href="/termsofuse"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              margin: '0',
              textDecoration: 'none',
              color: '#292929'
            }}
        >
            Terms of Use
        </a>
        <p
          style={{
            margin: '0',
          }}
        >
          Contact: cataractpreop@gmail.com
        </p>
      </div>
    </div>
  )
}
